// Invita y gana: el enlace juegoxima.com/?amigo=XIMA-1234 guarda el código de quien invita
// y se manda al crear la cuenta (registro, invitado o invitado que se registra).
const STORAGE_KEY = "xima_friend_ref";
const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;

const normalizeCode = (value) => {
  const raw = String(value || "").trim().toUpperCase();
  if (/^\d{4,6}$/.test(raw)) return `XIMA-${raw}`;
  return /^XIMA-\d{4,6}$/.test(raw) ? raw : "";
};

export const captureFriendReferralFromUrl = () => {
  if (typeof window === "undefined") return "";
  try {
    const params = new URLSearchParams(window.location.search || "");
    const code = normalizeCode(params.get("amigo") || params.get("ref"));
    if (!code) return "";
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ code, at: Date.now() }));
    return code;
  } catch (error) {
    return "";
  }
};

export const getStoredFriendReferral = () => {
  if (typeof window === "undefined") return "";
  try {
    const parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "null");
    if (!parsed || Date.now() - Number(parsed.at || 0) > MAX_AGE_MS) return "";
    return normalizeCode(parsed.code);
  } catch (error) {
    return "";
  }
};

export const withFriendReferral = (payload = {}) => {
  const ref = getStoredFriendReferral();
  return ref ? { ...payload, ref } : payload;
};

export const buildFriendInviteLink = (playerCode) => {
  const code = normalizeCode(playerCode);
  return code ? `https://juegoxima.com/?amigo=${code}` : "https://juegoxima.com/";
};
